"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpful_merge_1 = require("helpful-merge");
var rxjs_1 = require("rxjs");
var ConfigStore_1 = require("../Store/ConfigStore");
var Store_1 = require("../Store/Store");
var ConfigState_1 = require("./ConfigState");
var State = /** @class */ (function () {
    function State(options) {
        if (options === void 0) { options = {}; }
        this.history = [{}];
        this.isTraversing = false;
        this.update$ = new rxjs_1.BehaviorSubject(null);
        this.config = new ConfigState_1.default();
        this.historyIndex = 0;
        helpful_merge_1.default(this.config, options);
    }
    Object.defineProperty(State.prototype, "snapshot", {
        get: function () {
            return this.history[this.historyIndex];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(State.prototype, "isActioning", {
        get: function () {
            return !Object.isFrozen(this.snapshot);
        },
        enumerable: true,
        configurable: true
    });
    State.prototype.createStore = function (config, initialValue) {
        if (this.historyIndex > 0) {
            throw new Error('Cannot create store after state initialisation');
        }
        if (Object.isFrozen(this.snapshot)) {
            this.history[0] = __assign({}, this.snapshot);
        }
        if (!this.stores)
            this.stores = {};
        var storeConfig = helpful_merge_1.default(new ConfigStore_1.default(), config);
        var name = storeConfig.name, model = storeConfig.model, actions = storeConfig.actions;
        if (!name || typeof name !== 'string') {
            throw new TypeError('Invalid store name provided');
        }
        if (!model || typeof model !== 'function') {
            throw new TypeError("Invalid store model provided for store `" + name + "`");
        }
        if (!actions || typeof actions !== 'function') {
            throw new TypeError("Invalid actions resolver provided for store `" + name + "`");
        }
        var store = this.stores[storeConfig.name] = new Store_1.default(this, storeConfig, initialValue);
        Object.freeze(this.snapshot);
        return store;
    };
    State.prototype.pushNextSnapshotToHistory = function (nextSnapshot) {
        if (this.history.length === this.config.maxHistoryLength) {
            this.history.shift();
        }
        else {
            this.historyIndex++;
        }
        this.history.push(nextSnapshot);
    };
    State.prototype.go = function (traversalAmount) {
        var initialState = this.snapshot;
        var nextHistoryIndex = this.historyIndex + traversalAmount;
        if (nextHistoryIndex > this.history.length - 1 || nextHistoryIndex < 0) {
            throw new RangeError('History index out of bounds');
        }
        this.isTraversing = true;
        this.historyIndex = nextHistoryIndex;
        for (var key in this.stores) {
            var store = this.stores[key];
            if (this.snapshot[store.name] !== initialState[store.name]) {
                store.update$.next(store.value);
            }
        }
        this.isTraversing = false;
    };
    return State;
}());
exports.default = State;
//# sourceMappingURL=State.js.map